module.exports = __webpack_public_path__ + "img/gy.50c75cf2.svg";